import React, { useEffect, useState } from "react";
import { useWindowSize } from "../componets/useWindowSize";
import AppShell from "../componets/AppShell";

import {
  getButtonCollapsedMemory,
  getHorarioInscricao,
  getInicioListaEspera,
  getLimitePresenca,
  getMenuCollapsedMemory,
  getVersionApp,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";

const Regras: React.FC = () => {
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  const handleMenuToggle = () => {
    const newButtonCollapsed = !isButtonCollapsed;
    const newMenuCollapsed = !isMenuCollapsed;
    setIsButtonCollapsed(newButtonCollapsed);
    setButtonCollapsedmemory(newButtonCollapsed);
    setIsMenuCollapsed(newMenuCollapsed);
    setMenuCollapsedmemory(newMenuCollapsed);
  };

  return (
    <AppShell
      isMenuCollapsed={isMenuCollapsed}
      onToggleMenu={handleMenuToggle}
    >
      <section className="panel-glass rounded-[2rem] p-4 text-white sm:p-8">
        <div className="mb-6">
          <h2 className="text-xl font-semibold sm:text-2xl">Regras</h2>
        </div>

        <div className="panel-soft space-y-4 rounded-[1.5rem] p-4 text-sm leading-relaxed sm:p-6 sm:text-base">
          <p className="text-zinc-100">
            <strong>Regras de exibição da lista de presença:</strong>
          </p>

          <ul className="list-disc space-y-3 pl-5 text-zinc-200">
            <li>
              As{" "}
              <strong>
                inscrições abrem toda segunda-feira às {getHorarioInscricao()}h
              </strong>{" "}
              e se encerram na <strong>terça-feira às 19h</strong>.
            </li>

            <li>
              A partir do <strong>{getInicioListaEspera()}º nome</strong>, os inscritos entram na{" "}
              <strong>lista de espera</strong>.
              <br />
              Visualmente, esses nomes devem aparecer com o{" "}
              <span className="font-semibold text-pink-300">texto em rosa</span>.
            </li>
            <li>
              A <strong>classificação</strong> da lista segue as prioridades:
              <ul className="mt-2 list-disc space-y-2 pl-5 text-zinc-300">
                <li>
                  <strong>🔹 Prioridade 1:</strong> Usuários com{" "}
                  <strong>1 jogo</strong>.
                  <br />
                  Ordenados por <strong>data de inscrição</strong> (quem se
                  inscreveu primeiro aparece antes).
                </li>
                <li>
                  <strong>🔹 Prioridade 2:</strong> Usuários com{" "}
                  <strong>2 jogos</strong>.
                  <br />
                  Também ordenados por <strong>data de inscrição</strong>.
                </li>
                <li>
                  <strong>🔹 Prioridade 3:</strong> Usuários com{" "}
                  <strong>3 jogos</strong>.
                  <br />
                  Também ordenados por <strong>data de inscrição</strong>.
                </li>
                <li>
                  <strong>🔹 Prioridade 4:</strong> Usuários com{" "}
                  <strong>4 jogos</strong>.
                  <br />
                  Também ordenados por <strong>data de inscrição</strong>.
                </li>
              </ul>
            </li>
            <li>
              <strong>❗ Cancelamentos:</strong>
              <br />
              Cancelamentos feitos na <strong>segunda-feira</strong>{" "}
              <strong>não contam como participação</strong>.
              <br />
              Já o cancelamento feito na <strong>terça-feira</strong>,{" "}
              <strong>por quem estava entre os {getLimitePresenca()} primeiros</strong>,{" "}
              <strong>contará como uma participação</strong>.
            </li>
            <li>
              <strong>📅 Contagem de jogos:</strong>
              <br />A contagem de jogos de cada participante é{" "}
              <strong>zerada no início de cada mês</strong>.
              <br />
              Isso garante que todos tenham chances equilibradas a cada novo
              mês.
            </li>
            <li>
              <strong>⛈️ Condições climáticas:</strong>
              <br />
              Em caso de <strong>chuva ou condições adversas</strong>, o jogo
              poderá ser <strong>cancelado</strong>.
              <br />
              Se houver cancelamento,{" "}
              <strong>quem estiver na lista de presença</strong>{" "}
              <strong>não terá a participação contabilizada</strong> no total
              de jogos.
            </li>
          </ul>
        </div>
      </section>

      <div className="w-full py-2 text-center">
        <span className="text-xs text-zinc-500 sm:text-sm">
          Developed by Samuel Stork
        </span>{" "}
        <span className="text-xs text-zinc-600 sm:text-sm">
          {getVersionApp()}
        </span>
      </div>
    </AppShell>
  );
};

export default Regras;
